import HCLTreeMxGraph from "../HCLTreeMxGraph";
import HCLTreeMxConstraintHandler from "../ConstraintHandler/HCLTreeMxConstraintHandler";
import HCLTreeVertex from "../../HCLTreeNode/HCLTreeVertex";
import {mxConnectionConstraint, mxConnectionHandler, mxMouseEvent} from "mxgraph-js";


abstract class HCLTreeMxConnectionHandler extends mxConnectionHandler {

  sourceConstraint: mxConnectionConstraint;

  protected constructor(graph: HCLTreeMxGraph, factoryMethod: Function) {
    super(graph, factoryMethod);
    this.constraintHandler = new HCLTreeMxConstraintHandler(graph);
  }


  static dfsForID(root: HCLTreeVertex, id: any): boolean {
    if (root.getId() === id) {
      return true;
    }
    return root.getChildren().some(child => HCLTreeMxConnectionHandler.dfsForID(child as HCLTreeVertex, id));
  }

  static doesPathExistBetween(source: HCLTreeVertex, target: HCLTreeVertex): boolean {
    return HCLTreeMxConnectionHandler.dfsForID(target, source.getId());
  }

  /**
   * Function that is used for creating new edges.  The function takes the source and target mxCell as the first and
   * second argument and returns a new mxCell that represents the edge.  This is used in createEdge.
   * @param source
   * @param target
   * @param style
   */

  // /**
  //  * Create the appropriate edge type for the given source and target, or throw a ValidationError (includes string)
  //  * which describes the error.
  //  * @param source
  //  * @param target
  //  */
  // protected abstract createEdgeForConnection(source: MxGraphType.mxCell, target: MxGraphType.mxCell): MxGraphType.mxCell  {
  //
  // }

  updateEdgeState(current: any, constraint: any): void {
    if (current != null && this.previous != null)
    {
      var constraints = this.graph.getAllConnectionConstraints(this.previous, false);
      var nearestConstraint = null;
      var dist = null;

      for (var i = 0; i < constraints.length; i++)
      {
        var cp = this.graph.getConnectionPoint(this.previous, constraints[i]);

        if (cp != null)
        {
          var tmp = (cp.x - current.x) * (cp.x - current.x) + (cp.y - current.y) * (cp.y - current.y);

          if (dist == null || tmp < dist)
          {
            nearestConstraint = constraints[i];
            dist = tmp;
          }
        }
      }

      if (nearestConstraint != null)
      {
        this.sourceConstraint = nearestConstraint;
      }
    }
    super.updateEdgeState(current, constraint);
  }

  // getSourcePerimeterPoint(state: any, next: any, me: any): any {
  //   console.log(state, next, me);
  // }
  //
  // getTargetPerimeterPoint(state: any, me: any): any {
  //   console.log(state, me);
  // }

  // isValidSource(cell: any, me: any): any {
  //   console.log(cell, me);
  // }
  //
  //
  // isValidTarget(cell: any, me: any): any {
  //   console.log(cell, me);
  // }

  mouseMove(sender: HCLTreeMxGraph, me: mxMouseEvent): void {
    this.sourceConstraint = null;
    //console.log(sender, me);
    super.mouseMove(sender, me);
  }

  /**
   * Hook to update the icon position(s) based on a mouseOver event. This is
   * an empty implementation.
   *
   * Parameters:
   *
   * state - <mxCellState> that represents the source cell state.
   * next - <mxPoint> that represents the next point along the previewed edge.
   * me - <mxMouseEvent> that represents the mouse move.
   */
  // getSourcePerimeterPoint(state: MxGraphType.mxCellState, next: MxGraphType.mxPoint, me: MxGraphType.mxMouseEvent ) {
  //   console.log(state, next, me, this.previous);
  //   let result: MxGraphType.mxPoint = null;
  //
  //   if (this.previous !== null && next !== null)
  //   {
  //     const constraints = this.graph.getAllConnectionConstraints(this.previous, true);
  //
  //     let nearestConstraint: MxGraphType.mxConnectionConstraint = null;
  //     let nearest: MxGraphType.mxPoint = null;
  //     let dist: number = null;
  //
  //     constraints.forEach((constraint: MxGraphType.mxConnectionConstraint) => {
  //       let cp = this.graph.getConnectionPoint(this.previous, constraint);
  //       if (cp !== null) {
  //         let tmp = (cp.x - next.x) * (cp.x - next.x) + (cp.y - next.y) * (cp.y - next.y);
  //         if (!dist || tmp < dist) {
  //           nearestConstraint = constraint;
  //           nearest = cp;
  //           dist = tmp;
  //         }
  //       }
  //     });
  //
  //     if(nearestConstraint !== null) {
  //       this.sourceConstraint = nearestConstraint;
  //       return nearest;
  //     }
  //   }
  //
  //   return super.getSourcePerimeterPoint(state, next, me);
  // }
}

export default HCLTreeMxConnectionHandler;
